import { Component } from "react";
import "./App.css";

import { BrowserRouter as Router } from "react-router-dom";

import Header from "./components/common/Header";
import Main from "./components/Main";
import Footer from "./components/common/Footer";
import LangContext from "./contexts/LangContext";

class App extends Component {
  constructor() {
    super();

    this.state = {
      tab: this.getTab(),
      lang: this.getLang(),
    };
    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleLanguageChange = this.handleLanguageChange.bind(this);
  }

  getTab() {
    let search = window.location.search;
    search = search.replace("?", "");
    search = search.split("&");
    search = search && search.find((a) => a.includes("type="));
    search = search && search.split("=")[1];
    if (search && search.toLowerCase() === "provincial") return search.toLowerCase();
    else return "federal";
  }

  getLang() {
    let search = window.location.search;
    search = search.replace("?", "");
    search = search.split("&");
    search = search && search.find((a) => a.includes("lang="));
    search = search && search.split("=")[1];
    if (search && search.toLowerCase() === "en") return "en";
    else return "np";
  }

  handleTabChange(el) {
    let type = el.target.getAttribute("datavalue");
    if (!type && el.target.tagName !== "BUTTON") {
      el.preventDefault();
      type = el.target.closest("button").getAttribute("datavalue");
    }

    const url = new URL(window.location.href);
    url.searchParams.delete("type");
    url.searchParams.append("type", type === "provincial" ? "provincial" : "federal");

    if (window.history.replaceState) {
      //prevents browser from storing history with each change
      window.history.replaceState({}, document.title, url);
    }
    this.setState({ tab: type });
  }

  handleLanguageChange(el) {
    const lang = el.target.value;

    const url = new URL(window.location.href);
    url.searchParams.delete("lang");
    url.searchParams.append("lang", lang === "en" ? "en" : "np");

    if (window.history.replaceState) {
      //prevents browser from storing history with each change:
      window.history.replaceState({}, document.title, url);
    }

    this.setState({ lang: lang });
  }

  render() {
    return (
      <Router>
        <LangContext.Provider value={{ lang: this.state.lang }}>
          <Header tab={this.state.tab} handleLanguageChange={this.handleLanguageChange} />
          <Main tab={this.state.tab} handleTabChange={this.handleTabChange} />
          <Footer tab={this.state.tab} handleTabChange={this.handleTabChange} handleLanguageChange={this.handleLanguageChange} />
        </LangContext.Provider>
      </Router>
    );
  }
}

export default App;
